import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'areaType',
})
export class AreaTypePipe implements PipeTransform {
  transform(items: any[] | undefined, type: string | string[]): any[] {
    if (!items || !type) return [];
  
    if (Array.isArray(type)) {
      return items.filter(item => item && type.includes(item.type));
    }
  
    return items.filter(item => item?.type === type);
  }
}
